<div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
        <center>
            <mat-spinner [diameter]="50" [strokeWidth]="4"></mat-spinner>
        </center>
        <p>Veuillez patienter, publication en cours...</p>
    </div>
</div>

<mat-card class="mat-dialog-container">
    <mat-card-header>
        <mat-card-title>Créer une story</mat-card-title>
        <mat-card-subtitle>
            <button class="close-btn" mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-subtitle>
    </mat-card-header>

    <div class="story-content">
        <div class="media-container" 
             (mousemove)="onDrag($event)"
             (mouseup)="onDragEnd()"
             [class.has-media]="selectedImage || selectedVideo"
             [class.dragging]="isDragging">
          
            <!-- Prévisualisation du média -->
            <div class="media-preview-container" *ngIf="selectedImage || selectedVideo">
                <img *ngIf="selectedImage" [src]="selectedImage" alt="Story preview" class="media-preview">
                <video *ngIf="selectedVideo" [src]="selectedVideo" controls class="media-preview"></video>
                <button mat-icon-button class="remove-media" (click)="clearMedia()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- Texte de la story -->
            <div *ngIf="storyText" 
                 class="story-text"
                 [style.color]="textColor"
                 [style.left.%]="textPosition.x"
                 [style.top.%]="textPosition.y"
                 (mousedown)="onDragStart($event)"
                 [style.cursor]="isDragging ? 'grabbing' : 'grab'">
                {{ storyText }}
            </div>

            <!-- Message si aucun média n'est sélectionné -->
            <div *ngIf="!selectedImage && !selectedVideo" class="upload-prompt" (click)="fileInput.click()">
                <mat-icon>add_photo_alternate</mat-icon>
                <p>Ajouter une photo ou une vidéo</p>
            </div>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="story-controls">
            <!-- Sélection du fichier -->
            <input type="file" 
                   #fileInput 
                   (change)="onFileSelected($event)" 
                   accept="image/*,video/*" 
                   style="display: none">
            
            <div class="text-controls">
                <mat-form-field appearance="outline" class="text-input">
                    <mat-label>Ajouter du texte</mat-label>
                    <input matInput
                           [(ngModel)]="storyText" 
                           placeholder="Écrivez quelque chose...">
                </mat-form-field>
                
                <button mat-icon-button
                        class="color-picker-button"
                        [style.color]="textColor"
                        (click)="colorInput.click()">
                    <mat-icon>format_color_text</mat-icon>
                </button>
                <input type="color" 
                       #colorInput
                       [(ngModel)]="textColor"
                       class="color-picker"
                       style="display: none">
            </div>

            <div class="action-buttons">
                <button mat-stroked-button
                        color="primary"
                        class="media-button" 
                        (click)="fileInput.click()"
                        *ngIf="selectedImage || selectedVideo">
                    <mat-icon>photo_library</mat-icon>
                    Changer le média
                </button>

                <button mat-flat-button 
                        color="primary"
                        class="publish-button" 
                        (click)="publishStory()"
                        [disabled]="!selectedImage && !selectedVideo">
                    <mat-icon>publish</mat-icon>
                    Publier
                </button>


            </div>

            
        </div>
    </div>
</mat-card>
